import { Injectable } from '@angular/core';
export var TabsetConfig = (function () {
    function TabsetConfig() {
        /** provides default navigation context class: 'tabs' or 'pills' */
        this.type = 'tabs';
    }
    TabsetConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    TabsetConfig.ctorParameters = function () { return []; };
    return TabsetConfig;
}());
//# sourceMappingURL=tabset.config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/tabs/tabset.config.js
// module id = 93
// module chunks = 0